<template>
    <div class="panel panel-default panel-dashboard">
        <div class="panel-heading">
            <h5 class="pull-left">
                Renewed
            </h5>

            <div class="pull-right text-muted" style="padding-top: 5px;">
                {{ year }}
            </div>

            <div class="clearfix"></div>
        </div>

        <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

        <div v-else class="panel-body text-center">
            <span style="font-size: 36px;">
                {{ formattedNumber }}
            </span>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import SaveHeight from '@/mixins/SaveHeight'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
    components: {LoadingSpinner},

    mixins: [SaveHeight],

    props: ['year', 'metricType', 'portal', 'user', 'subscriberType'],

    data() {
        return {
            loading: true,
            number: null
        }
    },

    mounted() {
        this.load()
    },

    watch: {
        year() {
            this.load()
        },

        metricType() {
            this.load()
        },

        portal() {
            this.load()
        },

        user() {
            this.load()
        },

        subscriberType() {
            this.load()
        }
    },

    computed: {
        filters() {
            let filters = [
                {dimension: 'is_first_subscription_period', value: false}
            ]

            if (this.portal && this.portal.length) {
                filters.push({dimension: 'portal_id', operator: 'in', value: this.portal})
            }

            if (this.user) {
                filters.push({dimension: 'user_id', value: this.user})
            }

            if (this.subscriberType) {
                filters.push({dimension: 'subscriber_type', value: this.subscriberType})
            }

            return filters
        },

        metric() {
            return 'starting_subscription_' + this.metricType
        },

        formattedNumber() {
            if (this.metricType === 'revenue') {
                return this.$options.filters.price(this.number)
            }

            return this.$options.filters.number(this.number)
        }

    },

    methods: {
        load() {
            this.saveHeight()

            this.loading = true

            http.post('/api/v1/reports/dashboard', {
                start: moment().year(this.year).startOf('year').format('YYYY-MM-DD'),
                end: moment().year(this.year).endOf('year').format('YYYY-MM-DD'),
                metrics: [this.metric],
                filters: this.filters
            })
                .then(response => {
                    this.number = response.data.data[0][this.metric]

                    this.loading = false
                })
        }
    }
}
</script>
